import { inject, observer } from "mobx-react";
import React from "react";
import DropDown from "../../../sharedComponents/dropDown/dropDown";
import { PreviousInsurerNameDropDown } from "../../../../helpers/previousInsurerName";
import { ProposalStore } from "../../../../stores/proposalStore";

interface PreviousInsurerNameProps {
    proposalStore?: ProposalStore;

}

export function PreviousInsurerName(props: PreviousInsurerNameProps) {
    return (
        <div className="section">
            <div className="label">{PreviousInsurerNameDropDown.label}</div>
            <DropDown
                onChange={(val) => {
                    props.proposalStore!.setPreviousInsurerName(val);
                }}
                value={props.proposalStore!.previousInsurerName}
                items={PreviousInsurerNameDropDown.dropDown}
            />
        </div>
    );
}

export default inject("proposalStore")(observer(PreviousInsurerName));
